import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

const LoadingState = ({ isDesktop }) => {
	return (
		<div
			data-testid="loadingState"
			className="m-auto d-flex flex-column align-items-center"
			style={{ maxWidth: isDesktop ? '27rem' : '35rem' }}
		>
			<Skeleton width={isDesktop ? '75%' : '100%'} height="3rem" />
			<Skeleton
				skeletonClasses={`mt-4 ${isDesktop ? 'mx-auto' : ''}`}
				width={isDesktop ? '75%' : '100%'}
				height={isDesktop ? '3rem' : '5rem'}
			/>
			<div className={`border mt-4 ${isDesktop ? 'w-75' : 'w-100'}`}>
				<Skeleton
					skeletonClasses="mx-auto"
					width="100%"
					height={isDesktop ? '14rem' : '24rem'}
				/>
				<Skeleton
					skeletonClasses={`${isDesktop ? 'mx-auto' : ''} my-4`}
					width={isDesktop ? '90%' : '100%'}
					height="6rem"
				/>
			</div>
		</div>
	);
};

LoadingState.propTypes = {
	isDesktop: PropTypes.bool
};

export default LoadingState;
